import RightPanelHeading from 'features/unifiedFlow/contentPage/components/layout/RightPanelHeading'

import CampaignDetails from './CampaignDetails'

const CampaignLogs = ({ expandedIcons }) => {
  return (
    <>
      <RightPanelHeading
        data-testid="logs-header"
        text="Logs"
        className="p-6 mb-4"
        icons={expandedIcons}
      />
      <CampaignDetails />
    </>
  )
}

export default CampaignLogs
